import http from '../../../../api/http'

// 온라인 특별채용관 현황 리스트
function ojfListByUserId(paramObj) {
    return http.post('/mypage/ojf/onlineJobFair/retrieveOjfPagingByUserId', {
        searchOjfStateGb: paramObj.searchOjfStateGb || "01,02,03,04", // 01,02,03,04
        searchJoinStateGb: paramObj.searchJoinStateGb || "01,02,03,04,11,21", // 01,02,03,04,11,21
        ojfGb: paramObj.ojfGb,
        pageNumber: paramObj.pageNumber || 0, // 0
        size: paramObj.size || 30,
        userId: paramObj.userId, // 0
    });
}

// 온라인 특별채용관 현황 상세 상단 정보
function ojfDetailByIdAndUserIdForMyPage(id) {
    return http.get(`/mypage/ojf/onlineJobFair/retrieveOjfByOjfIdAndUserIdForMyPage?ojfId=${id}`);
}

// 참기신청 조회
function ojfDetailEntryListByIdAndUserId(id) {
    return http.get(`/mypage/ojf/entry/retrieveEntryByOjfIdAndUserId?ojfId=${id}`);
}

// 참기신청시 기존 참가신청 여부 확인
function ojfDetailEntryListByIdAndUserId2(id) {
    return http.get(`/mypage/ojf/entry/retrieveEntryByOjfIdAndUserId2?ojfId=${id}`);
}

// 참가신청 등록
function ojfCreateEntry(
    ojfId, joinPurpose,
    intvInYn, intvAbleDay, agreePrivacyYn,
) {
    return http.post('/mypage/ojf/entry/createEntry', {
        ojfId, // 0
        joinPurpose, // "string"
        intvInYn, // "string"
        intvAbleDay, // "string"
        agreePrivacyYn, // "N"
    })
}

// 참가신청 수정
function ojfUpdateEntry(
    ojfId, joinPurpose,
    intvInYn, intvAbleDay,
) {
    return http.post('/mypage/ojf/entry/updateEntry', {
        ojfId, // 0
        joinPurpose, // "string"
        intvInYn, // "string"
        intvAbleDay, // "string"
    })
}

// 참가신청 취소
function ojfDeleteEntry(
    ojfId
) {
    return http.post('/mypage/ojf/entry/deleteEntry', {
        ojfId, // 0
    })
}


// 이력서 관리 및 입사지원 현황
function ojfResumeList(paramObj) {
    return http.post('/mypage/ojf/ojfResume/retrieveOjfResumeListPaging', {
        ojfId: paramObj.ojfId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 인재정보(이력서) 공개 여부
function ojfResumeResOpenYn(paramObj) {
    return http.post('/mypage/ojf/ojfResume/updateStatusOjfResumeResOpenYn', {
        resumeId: paramObj.resumeId, // 0
        ojfId: paramObj.ojfId, // 0
        resOpenYn: paramObj.resOpenYn, // string
    })
}

// 입사지원
function retrieveApplicantList(paramObj) {
    return http.post('/mypage/ojf/applicant/retrieveApplicantListPaging', {
        resumeId: paramObj.resumeId, // 0
        ojfId: paramObj.ojfId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 기업
function ojfInterestCorpList(paramObj) {
    return http.post('/mypage/ojf/interestHallEntry/retrieveInterestHallEntryCorpListPaging', {
        ojfId: paramObj.ojfId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 기업 유무
function ojfInterestHallEntryYn(paramObj) {
    return http.get(`/mypage/ojf/interestHallEntry/retrieveInterestHallEntryYn?ojfId=${paramObj.ojfId}&corpId=${paramObj.corpId}`);
}

// 관심 기업 관심여부 변경
function ojfInterestCorpEntryYn(paramObj) {
    return http.post('/mypage/ojf/interestHallEntry/updateInterestHallEntryYn', {
        ojfId: paramObj.ojfId, // 0
        resumeId: paramObj.resumeId, //0,
        corpId: paramObj.corpId, // 0
        userId: paramObj.userId, //0
        interestYn: paramObj.interestYn, // string
        requestUserId: paramObj.requestUserId, // 0
    })
}

// 채용공고
function ojfJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/jobNotice/retrieveJobNoticeListPaging', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        resumeId: paramObj.resumeId, //0,
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 공고 목록
function ojfInterestJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/interestJobNotice/retrieveInterestJobNoticeListPaging', {
        ojfId: paramObj.ojfId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 공고 관심여부 변경
function ojfInterestNoticeYn(paramObj) {
    return http.post('/mypage/ojf/interestJobNotice/updateInterestNoticeYn', {
        ojfId: paramObj.ojfId, // 0
        userId: paramObj.userId, //0
        jobNoticeSeq: paramObj.jobNoticeSeq,
        interestNoticeYn: paramObj.interestNoticeYn,
    })
}

// 관심 공고 유무
function ojfInterestJobNoticeYn(paramObj) {
    return http.get(`/mypage/ojf/interestJobNotice/retrieveInterestJobNoticeYn?jobNoticeSeq=${paramObj.jobNoticeSeq}`);
}

// 받은 면접제안
function ojfInterestProposalList(paramObj) {
    return http.post('/mypage/ojf/interviewProposalEntry/retrieveInterviewProposalEntryListPaging', {
        ojfId: paramObj.ojfId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 받은 면접제안 상태변경
function ojfUpdateIntvPropsState(paramObj) {
    return http.post('/mypage/ojf/interviewProposalEntry/updateIntvPropStateGb', {
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        resumeId: paramObj.resumeId, // 0
        intvPropStateGb: paramObj.intvPropStateGb, // string
        userId: paramObj.userId, // 0
    })
}

// 이력서 조회
function ojfResumeDetail(paramObj) {
    return http.get(`/mypage/ojf/ojfResume/retrieveOjfResume?resumeId=${paramObj.resumeId}&hidden=${paramObj.hidden}`);
}

// 이력서 수정
function ojfResumeUpdate(
    resumeId, ojfId, title,
    interests, desiredJob, desiredSalary, // 기본 정보
    residenceArea1, residenceArea2, // 거주지역
    introOpenYn, introAline, selfIntro, // 소개
    eduHistOpenYn, eduHistoris, // 학력
    portfolioOpenYn, portfolios, // 포트폴리오
    certForeignOpenYn, certificates, languageTests, foreignLanguages, // 자격증및외국어
    jobHistOpenYn, jobHistorys, // 업무경험
    milOpenYn, milServiceGb // 병역
) {
    return http.post(`/mypage/ojf/ojfResume/updateOjfResume`, {
        resumeId,
        ojfId,
        title, // 이력서 제목
        residenceArea1, // 거주지역1
        residenceArea2, // 거주지역2
        interests, // 관심카테고리
        desiredJob, // 희망직무
        desiredSalary, // 희망연봉
        introOpenYn: introOpenYn ? 'Y' : 'N', // 공개여부
        introAline, // 한줄소개
        selfIntro, // 자기소개
        eduHistOpenYn: eduHistOpenYn ? 'Y' : 'N',  // 공개여부
        eduHistoris,
        portfolioOpenYn: portfolioOpenYn ? 'Y' : 'N',  // 공개여부
        portfolios,
        certForeignOpenYn: certForeignOpenYn ? 'Y' : 'N',  // 공개여부
        certificates,
        languageTests,
        foreignLanguages,
        jobHistOpenYn: jobHistOpenYn ? 'Y' : 'N',  // 공개여부
        jobHistorys,
        milOpenYn: milOpenYn ? 'Y' : 'N',  // 공개여부
        milServiceGb,
    });
}

// 이력서 등록
function ojfResumeCreate(
    ojfId, title,
    interests, desiredJob, desiredSalary, // 기본 정보
    residenceArea1, residenceArea2, // 거주지역
    introOpenYn, introAline, selfIntro, // 소개
    eduHistOpenYn, eduHistoris, // 학력
    portfolioOpenYn, portfolios, // 포트폴리오
    certForeignOpenYn, certificates, languageTests, foreignLanguages, // 자격증및외국어
    jobHistOpenYn, jobHistorys, // 업무경험
    milOpenYn, milServiceGb // 병역
) {
    return http.post(`/mypage/ojf/ojfResume/createOjfResume`, {
        ojfId,
        title, // 이력서 제목
        residenceArea1, // 거주지역1
        residenceArea2, // 거주지역2
        interests, // 관심카테고리
        desiredJob, // 희망직무
        desiredSalary, // 희망연봉
        introOpenYn: introOpenYn ? 'Y' : 'N', // 공개여부
        introAline, // 한줄소개
        selfIntro, // 자기소개
        eduHistOpenYn: eduHistOpenYn ? 'Y' : 'N',  // 공개여부
        eduHistoris,
        portfolioOpenYn: portfolioOpenYn ? 'Y' : 'N',  // 공개여부
        portfolios,
        certForeignOpenYn: certForeignOpenYn ? 'Y' : 'N',  // 공개여부
        certificates,
        languageTests,
        foreignLanguages,
        jobHistOpenYn: jobHistOpenYn ? 'Y' : 'N',  // 공개여부
        jobHistorys,
        milOpenYn: milOpenYn ? 'Y' : 'N',  // 공개여부
        milServiceGb,
    });
}

// 이력서 삭제
function ojfResumeDelete(resumeId) {
    return http.post(`/mypage/ojf/ojfResume/deleteOjfResume`, {
        resumeId,
    });
}

// 입사지원
function ojfCreateApplyStateGb(paramObj) {
    return http.post('/mypage/ojf/applicant/createApplicant', {
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        resumeId: paramObj.resumeId, // 0
        ojfId: paramObj.ojfId, // 0
    })
}

// 잆사지원 상태변경
function ojfUpdateApplyStateGb(paramObj) {
    return http.post('/mypage/ojf/applicant/updateApplyStateGb', {
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        resumeId: paramObj.resumeId, // 0
        ojfId: paramObj.ojfId, // 0
        applyStateGb: paramObj.applyStateGb, // string
    })
}

// 입사지원 여부
function ojfUpdateApplyByUserId(paramObj) {
    return http.post('/mypage/ojf/applicant/retrieveApplicantByUserId', {
        resumeId: paramObj.resumeId, // 0
        ojfId: paramObj.ojfId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 입사지원 이력서 조회
function ojfResumeListJobNoticeSeq(paramObj) {
    return http.post('/mypage/ojf/ojfResume/retrieveOjfResumeListPagingByJobNoticeSeq', {
        ojfId: paramObj.ojfId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 11
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 12
        userId: paramObj.userId, // 0
    })
}

// 이력서 파일 등록
function ojfResumeFile(paramObj) {
    return http.post('/mypage/ojf/ojfResume/createOjfResumeFile', {
        ojfId: paramObj.ojfId, // 0
        fileName: paramObj.fileName, // string
        fileSize: paramObj.fileSize, // string
        fileDir: paramObj.fileDir, // string
    })
}

// 면접 가능일
function ojfIntvDay(ojfId) {
    return http.get(`/mypage/ojf/onlineJobFair/retrieveOjfIntvDay?ojfId=${ojfId}`);
}


// 참가 확정 모달 유무 조회 - 구직자
function ojfEntryApproveModal() {
    return http.get(`/mypage/ojf/entry/retrieveEntryApproveModal`);
}

// 참가 확정 모달 행사 정보 확인
function ojfUpdateEntryApproveYn(ojfId) {
    return http.post(`/mypage/ojf/entry/updateEntryApproveYn`, {
        ojfId,
    });
}

// 온라인 특별채용관 참가 신청 상태 수정
function ojfUpdateEntryJoinStateByUserId(paramObj) {
    return http.post('/mypage/ojf/entry/updateEntryJoinStateByUserId', paramObj)
}

export default {
    ojfListByUserId, // 온라인 특별채용관 현황 리스트
    ojfDetailByIdAndUserIdForMyPage, // 온라인 특별채용관 현황 상세 상단 정보
    ojfDetailEntryListByIdAndUserId, // 참기신청 정보 조회 User
    ojfDetailEntryListByIdAndUserId2,   // 참기신청시, 기존 참가신청 여부 확인
    ojfCreateEntry, // 참가신청 등록
    ojfUpdateEntry, // 참가신청 수정
    ojfDeleteEntry, // 참가신청 삭제
    ojfResumeList, // 이력서 관리 및 입사지원 현황
    ojfResumeResOpenYn, // 인재정보(이력서) 공개 여부
    retrieveApplicantList, // 입사지원
    ojfInterestCorpList, // 관심 기업
    ojfInterestHallEntryYn, // 관심 기업 유무
    ojfInterestCorpEntryYn, // 관심 기업 관심여부 변경
    ojfJobNoticeList, // 채용공고
    ojfInterestJobNoticeList, // 관심 공고
    ojfInterestNoticeYn, // 관심 공고 관심여부 변경
    ojfInterestJobNoticeYn, // 관심 공고 유무
    ojfInterestProposalList, // 받은 면접제안
    ojfUpdateIntvPropsState, // 받은 면접제안 상태변경
    ojfResumeDetail, // 이력서 조회
    ojfResumeUpdate, // 이력서 수정
    ojfResumeCreate, // 아력서 등록
    ojfResumeDelete, // 이력서 삭제
    ojfCreateApplyStateGb, // 입사지원
    ojfUpdateApplyStateGb, // 잆사지원 상태변경
    ojfUpdateApplyByUserId, // 입사지원 여부
    ojfResumeListJobNoticeSeq, // 입사지원 이력서 조회
    ojfResumeFile, // 이력서 파일 등록
    ojfIntvDay, // 면접 가능일
    ojfEntryApproveModal, // 참가 확정 모달 유무 조회 - 구직자
    ojfUpdateEntryApproveYn, // 참가 확정 모달 행사 정보 확인
    ojfUpdateEntryJoinStateByUserId, // 온라인 특별채용관 참가 신청 상태 수정
};